const key = {
  TOKEN: "3499483a4e1ddfa04a6776fa92f37d85",
};

export default key;
